import API from '../../../../../services/api';

export const API_RECAMBISTAS_REPORTS = {
    nuevoReport: async (report) => {
        return API.post('/recambistas_report', report).then(res => res.data);
    },
    updateReport: async (report) => {
        return API.put('/recambistas_report/' + report.id, report).then(res => res.data);
    }
}